module.exports = __webpack_public_path__ + "static/media/fi-back.c2bb2328.svg";